import { getRuntimeConfig } from '../../lib/runtimeConfig';

const publicRuntimeConfig = getRuntimeConfig();

const ImageLoader = ({ src, width }) =>
  `${publicRuntimeConfig.assetsStaticBasePath}${src}?w=${width}`;

export default ImageLoader;
